import { render, staticRenderFns } from "./StepItemCampaign.vue?vue&type=template&id=068b70d2&scoped=true&"
import script from "./StepItemCampaign.vue?vue&type=script&lang=js&"
export * from "./StepItemCampaign.vue?vue&type=script&lang=js&"
import style0 from "./StepItemCampaign.vue?vue&type=style&index=0&id=068b70d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b70d2",
  null
  
)

export default component.exports